<template>
  <div class="roll-detail" @click="link(rollDetail)"> 
      <div class="card-content">
           <div v-if="rollDetail.discountType&&rollDetail.discountType==='LADDER'" 
           class="content-left" style="width:40%;border-right:1px dashed #FFD095;">
           <div v-if="rollDetail.couponType=='CASH'">
                <span style="font-size:13px;font-weight: 500;" >¥{{rollDetail.xx}}</span>
                <span v-if="rollDetail.dd>0" style="font-size:13px;"> ~ </span>
                 <span v-if="rollDetail.dd>0" style="font-size:13px;font-weight: 500;">¥</span>
                  <span v-if="rollDetail.dd>0" style="font-size:30px;font-weight: 500;">{{rollDetail.dd}}</span>
           </div>
           <div v-if="rollDetail.couponType=='DISCOUNT'">
                <span style="font-size:13px;font-weight: 500;">{{rollDetail.xx}}折</span>
                <span v-if="rollDetail.dd>0" style="font-size:13px;"> ~ </span>
                <span v-if="rollDetail.dd>0" style="font-size:30px;font-weight: 500;">{{rollDetail.dd}}</span><span style="font-size:13px;">折</span>
        </div>
        <div v-if="rollDetail.couponType=='GIFT'"><img :src="rollDetail.goodsUrl" style="width:24px;height:24px;"></div>
        <div style="font-size:11px;color:#9D7C64;">有效期至{{rollDetail.expiredDate}}</div>
    </div>
    <div class="card-content-left" style="width:40%;border-right:1px dashed #FFD095;" v-else>
         <div v-if="rollDetail.couponType=='CASH'&&rollDetail.couponAmount" 
         style="font-weight: 500;">¥<span style="font-size:30px;font-weight: 500;">{{rollDetail.couponAmount}}</span></div>
          <div v-if="rollDetail.couponType=='DISCOUNT'&&rollDetail.couponAmount"><span style="font-size:30px;font-weight: 500;">{{rollDetail.couponAmount}}</span>折</div>
          <div v-if="rollDetail.couponType=='GIFT'"><img :src="rollDetail.goodsUrl" style="width:24px;height:24px;"></div>
         <div style="font-size:11px;color:#9D7C64;">有效期至{{rollDetail.expiredDate}}</div>
    </div>
     <div class="card-contnet-right">
          <div class="card-right-title">
              <div class="title">{{rollDetail.onlineName}}</div>
                <div class="span">{{rollDetail.onlineDescription}}</div>
     </div>
      <div class="card-right-but">去领取</div>
       </div>
 </div>
 </div>
</template>
<script>
//  import env from '@/config/env'
 import Vue from 'vue'
export default {
  // 组件名称
  name: 'rollSlot',
  props: {
    rollDetail: {
      type: Object,
      default: function () {
        return {};
      },
    },
    shareId:{
      type: String,
      default: "",
    },
    vcardUrl:{
      type: String,
      default: "",
    },
    vcardData:{
      type: Object,
      default: function () {
        return {};
      },
    }
  },
  mounted() {
    console.log('this.rollDetail',this.rollDetail);
  },
  // 组件方法
  methods: {
    async link(rollDetail) {
      // console.log('rollDetail',rollDetail)
       let type='friend'
      if(rollDetail.ladders&&rollDetail.ladders.length>0){
        type='stair'
      }
      let params = {
       posterData:this.vcardData
      }
      let redirectUri='fissionEquitys/rollDetail'
      let url=`id=${rollDetail.couponId}&shareId=${this.shareId}&rollDetailType=${type}&vcardUrl=${
              this.vcardUrl
            }&vcardData=${encodeURIComponent(
              JSON.stringify(params.posterData)
            )}` 
      Vue.ss.set('pageUrl',url)
      console.log('redirectUri',redirectUri)
       Vue.ss.set('redirectUri',redirectUri)
      console.log(url)
      console.log('pageUrl',Vue.ss.get('pageUrl'))
      if(this.$store.getters.isWeiXin){
        await this.$store.dispatch("wxLogin/wxLogin");
      }else{
          this.$Dialog.alert({
            message: '请在微信客户端打开链接',
          }).then(() => {
            // on close
          });
      }
    }
  
  },

};
</script>

<style lang="less" scoped>
.card-content {
  background: #fcf6ea;
  padding: 16px 12px 16px 16px;
  font-size: 13px;
  color: #fd533e;
  border-radius: 5px;
  display: flex;
}
.card-contnet-right {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 14px;
  box-sizing: border-box;
  flex: 1;
}
.card-right-title {
  box-sizing: border-box;
  width: 115px;
}
.card-right-title .title {
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 10px;
}
.card-right-title  .span {
  font-size: 11px;
  color: #9d7c64;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.card-right-but {
  color: #fd533e;
  border: 1px solid #fd533e;
  box-sizing: border-box;
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 71px;
  height: 32px;
  margin-left: 6px;
}
</style>